export default {"src":"/_next/static/media/icon-grit.28b95f2c.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};